import React, { useState } from 'react';
import './ProductInfoModal.css'; // Add custom styles for the modal

const ProductInfoModal = ({ product, onClose }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0); // Manage the current image index

    // Handle next image
    const nextImage = () => {
        if (currentImageIndex < product.images.length - 1) {
            setCurrentImageIndex(currentImageIndex + 1);
        }
    };

    // Handle previous image
    const prevImage = () => {
        if (currentImageIndex > 0) {
            setCurrentImageIndex(currentImageIndex - 1);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="close-modal" onClick={onClose}>X</button>
                <h3>{product.name} Details</h3>

                {/* Image Navigation */}
                <div className="image-navigation">
                    <button className="nav-button" onClick={prevImage} disabled={currentImageIndex === 0}>
                        &#10094; {/* Left Arrow */}
                    </button>
                    <img 
                        src={product.images[currentImageIndex]} 
                        alt={product.name} 
                        className="modal-image" 
                    />
                    <button className="nav-button" onClick={nextImage} disabled={currentImageIndex === product.images.length - 1}>
                        &#10095; {/* Right Arrow */}
                    </button>
                </div>

                <div className="modal-info">
                    <div className="cart-item-color">
                      <p><strong>Color:</strong></p>
                      <div className="color-circle" style={{ backgroundColor: product.selectedColor || 'Not Selected'}}></div>
                    </div>

                    <p><strong>Size:</strong> {product.selectedSize || 'Not Selected'}</p>
                </div>
            </div>
        </div>
    );
};

export default ProductInfoModal;
